exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form__header[data-v-5936b378]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;align-items:center}.help[data-v-5936b378]{margin-left:10px;width:30px;height:30px}.mx-datepicker[data-v-5936b378]{width:100%}.mx-input[data-v-5936b378]{background-color:#fff!important}.trainer-container[data-v-5936b378]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;flex-direction:column;align-items:center}.instructions[data-v-5936b378]{width:100%;margin-top:20px}@media (min-width:640px){.form[data-v-5936b378]{width:600px}}", ""]);

// exports
